/*
  Styled - colour dot in the cart.

  A cart line is one chosen variant, so it gets a single dot next to its colour value
  ("Color: Black"), in the cart drawer and on the cart page. Values that are not real colour
  names (supplier codes, sizes, cuts) get no dot.

  The colour list mirrors snippets/styled-card-swatches.liquid. Keep the two in step.
*/
(function () {
  if (window.__spCartSwatches) return;
  window.__spCartSwatches = true;

  var MAP = [
    ['rose gold', '#b76e79'], ['yellow gold', '#d4af37'], ['white gold', '#e6e4dc'], ['wine red', '#722f37'],
    ['rose red', '#c21e56'], ['light blue', '#a9cce3'], ['sky blue', '#87ceeb'], ['lake blue', '#3f8fa6'],
    ['royal blue', '#2b4ba8'], ['navy blue', '#1f2a44'], ['deep blue', '#1f3a6e'], ['dark blue', '#1f2f5c'],
    ['dark green', '#1f4d3a'], ['army green', '#4b5320'], ['light green', '#a8d5a2'], ['dark grey', '#4a4a4a'],
    ['dark gray', '#4a4a4a'], ['light grey', '#cfcfcf'], ['light gray', '#cfcfcf'], ['light gold', '#e6cf8b'],
    ['burnt orange', '#cc5500'], ['off white', '#f5f1e6'], ['black', '#111111'], ['white', '#ffffff'],
    ['ivory', '#f6f0e0'], ['cream', '#f3e9d2'], ['beige', '#e3d3b8'], ['apricot', '#f5c9a0'], ['khaki', '#b5a579'],
    ['camel', '#c19a6b'], ['tan', '#c8a27a'], ['nude', '#e3bc9a'], ['coffee', '#5b3a29'], ['chocolate', '#4e2e1e'],
    ['brown', '#7b4b2a'], ['auburn', '#8a3324'], ['bronze', '#8c6239'], ['burgundy', '#6d1f2e'], ['maroon', '#6b1c23'],
    ['wine', '#722f37'], ['red', '#c8102e'], ['orange', '#f08a24'], ['yellow', '#f2c230'], ['golden', '#d4af37'],
    ['gold', '#d4af37'], ['champagne', '#ead9b5'], ['olive', '#6b7039'], ['green', '#2e8b57'], ['mint', '#aee0c9'],
    ['teal', '#1f7a7a'], ['turquoise', '#3cc4c0'], ['navy', '#1f2a44'], ['blue', '#2f5fb3'], ['purple', '#6f3fa0'],
    ['violet', '#7f4fc9'], ['lavender', '#bfa8e0'], ['lilac', '#c8a2c8'], ['mauve', '#b784a7'], ['pink', '#f4a6c0'],
    ['rosy', '#e0607e'], ['rose', '#e0607e'], ['fuchsia', '#c2187a'], ['silver', '#c4c7cc'], ['grey', '#8c8c8c'],
    ['gray', '#8c8c8c'], ['charcoal', '#36393d'], ['starlight', '#f0e8dc']
  ];
  var PATTERNS = [
    'leopard', 'camo', 'tie dye', 'print', 'printed', 'graffiti', 'mixed', 'mix', 'multicolor', 'mulitcolor',
    'multi', 'floral', 'plaid', 'stripe', 'striped', 'lighting', 'nebula'
  ];

  function colours(value) {
    var s = ' ' + value.toLowerCase().replace(/[^a-z]+/g, ' ') + ' ';
    var i;
    for (i = 0; i < PATTERNS.length; i++) {
      if (s.indexOf(' ' + PATTERNS[i] + ' ') > -1) return null;
    }
    var out = [];
    for (i = 0; i < MAP.length; i++) {
      var key = ' ' + MAP[i][0] + ' ';
      if (s.indexOf(key) > -1) {
        out.push(MAP[i][1]);
        if (out.length === 2) break;
        s = s.replace(key, ' ');
      }
    }
    return out.length ? out : null;
  }

  function decorate() {
    var rows = document.querySelectorAll('.product-option');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector('.styled-swatch-dot')) continue;
      var dt = row.querySelector('dt');
      var dd = row.querySelector('dd');
      if (!dt || !dd) continue;
      if (!/colou?r/i.test(dt.textContent)) continue;
      var c = colours(dd.textContent);
      if (!c) continue;
      var dot = document.createElement('span');
      dot.className = 'styled-swatch-dot';
      dot.setAttribute('aria-hidden', 'true');
      dot.style.setProperty('--sw-a', c[0]);
      dot.style.setProperty('--sw-b', c[1] || c[0]);
      dd.insertBefore(dot, dd.firstChild);
    }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () {
      timer = null;
      decorate();
    }, 60);
  }

  function start() {
    decorate();
    // The cart drawer and cart page replace their markup after every change, so watch for new rows.
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
